import { notify } from './msgbox.js';

const show = function(b64pdf)
{
	let _window = window.open();
	if (_window)
		_window.document.write(`<iframe width="100%" height="100%" src="data:application/pdf;base64,${b64pdf}"></iframe>`);
	else
		notify(`<a href="data:application/pdf;base64,${b64pdf}" download="report.pdf">Clique aqui para obter o relatório</a>`, 'Download');
}

export default show;

